import { FC, ReactNode } from 'react';
import { Box } from '@mui/material';
import { Header } from '@/components/Layout/Header';
import { Notification } from '@/components/UI';

interface LayoutProps {
  children: ReactNode;
  showHeader?: boolean;
}

export const Layout: FC<LayoutProps> = ({ children, showHeader = true }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: 'background.default',
      }}
    >
      {showHeader && <Header />}

      <Box component="main">{children}</Box>

      <Notification />
    </Box>
  );
};
